import { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';

interface ScrollTriggerProps {
  onInView: () => void;
  rootMargin?: string;
}

export const ScrollTrigger = ({ onInView, rootMargin = '100px' }: ScrollTriggerProps) => {
  const { ref, inView } = useInView({
    threshold: 0,
    rootMargin,
  });

  useEffect(() => {
    if (inView) {
      onInView();
    }
  }, [inView, onInView]);

  return <div ref={ref} className="h-px opacity-0" aria-hidden="true" />;
};
